import * as React from 'react';
import './styles.scss';
import { forwardRef } from 'react';
import { ErrorMessage } from 'react-hook-form';

export interface FormCheckboxProps extends React.HTMLAttributes<HTMLInputElement> {
  id: string;
  label: JSX.Element;
  errors?: any;
  showReadOnly?: boolean;
  checkBoxStyle?: "red" | undefined;
}

export const FormCheckbox = forwardRef<HTMLInputElement, FormCheckboxProps>(
  ({ id, label, errors, showReadOnly, checkBoxStyle, ...inputProps }, ref) => {
    const hasError: boolean = errors && errors[id];

    const addStyle = checkBoxStyle ? `input--checkbox__checkmark-` + checkBoxStyle : "";

    if (showReadOnly) {
      return (<>
        <div className="input--checkbox__container">
          <input {...inputProps}
            id={id}
            name={id}
            type="checkbox"
            className="input--checkbox"
            disabled={true}
            tabIndex={-1}
          />
          <label className="label--checkbox" htmlFor={id}>{label}

          </label>
        </div>
      </>)
    }

    return (
      <>
        <div className="input--checkbox__container">
          <input {...inputProps}
            id={id}
            name={id}
            type="checkbox"
            className={`input--checkbox ${hasError ? "input--error" : ""}`}
            disabled={showReadOnly || false}
            ref={ref}

          />
          <label className="label--checkbox" htmlFor={id}>{label}

          </label>
        </div>
        {hasError && <div className="form-input__error"><ErrorMessage errors={errors} name={id} /></div>}
      </>
    )
  }
);

